import { useGetEnabledCfcSolutions } from "../../../shared/feature-flags/use-get-enabled-cfc-solutions";
import { useNetworkCapabilities } from "../../network/public/use-network-capabilities";

/**
 * Single source of truth for PCF module access: the PCF service permission, or a
 * network supplier buying validated reports per calculation without an active service.
 */
export function useHasPcfAccess(): boolean {
  const { isPcfEnabled } = useGetEnabledCfcSolutions();
  const { isSupplier } = useNetworkCapabilities();

  return isPcfEnabled || isSupplier;
}
